import React from 'react';
import { Layout, Button, Space, Avatar, Typography, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined, BellOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useAuthApis from '../../apis/useAuthApis';
import { useContext } from 'react';
import { Context } from '../../context/Context';
// import useAuthApis from '../../apis/useAuthApis';

const { Header } = Layout;
const { Text } = Typography;

const DashboardHeader = ({ isDarkMode }) => {
  const navigate = useNavigate();
  const { logOutApi } = useAuthApis();
  const { userData } = useContext(Context);

  const handleLogout = async () => {
    await logOutApi();
  };

  const userMenuItems = {
    items: [
      {
        key: 'changePassword',
        label: 'Change Password',
        icon: <LockOutlined />,
        onClick: () => navigate('/change-password')
      },
      {
        key: 'logout',
        label: 'Logout',
        icon: <LogoutOutlined />,
        onClick: handleLogout,
      },
    ],
  };

  return (
    <Header style={{ 
      padding: '0 24px', 
      background: isDarkMode ? '#1f1f1f' : '#fff',
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      boxShadow: '0 1px 4px rgba(0,21,41,.08)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/478px-Seal_of_Uttar_Pradesh.svg.png"
          alt="UP Logo"
          style={{ height: '40px', marginRight: '16px' }}
        />
        <Text strong style={{ 
          fontSize: '18px',
          color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.85)',
        }}>
          UP Municipal Administration
        </Text>
      </div>
      
      <Space size="large">
        {/* <Button 
          type="text" 
          icon={<BellOutlined style={{ 
            fontSize: '20px',
            color: isDarkMode ? '#ffffff' : undefined,
          }} />}
        /> */}
        <Dropdown menu={userMenuItems} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar icon={<UserOutlined />} />
            <Text style={{ color: isDarkMode ? '#ffffff' : undefined }}>
              {userData?.name}
            </Text>
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default DashboardHeader; 